import { HorizontalStyle } from './HorizontalStyle'
import { withHorizontalStyle } from './withHorizontalStyle'

const ConnectedHorizontalStyle = withHorizontalStyle(HorizontalStyle)

export { ConnectedHorizontalStyle as HorizontalStyle }
